import { useFormContext } from 'react-hook-form';
import { Typography, Stack } from '@optimus-web/core';
import { SpacedForwardSlash } from '@mews-commander/ui';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { WithAvailabilityBlockId } from '@mews-commander/types';
import { useCommanderSelector } from '@mews-commander/utils';
import { AvailabilityAdjustmentFormValues } from '../../../../../types';
import {
    getAllReservationCapacityInBlockByDateFromForm,
    getSummaryAdjustmentValueFromForm,
} from '../../../../../selectors';
import { BlockSetupMatrixVectorTotalCell } from '../styles';

interface TotalCellEditableModeProps extends WithAvailabilityBlockId {
    dateTimeUtc: string;
}

const TotalCellEditableMode = ({ dateTimeUtc, availabilityBlockId }: TotalCellEditableModeProps) => {
    const occupancyInBlocksEnabledStage2 = useFeatureFlag(FeatureFlag.occupancyInBlocksEnabledStage2);

    const { watch } = useFormContext<AvailabilityAdjustmentFormValues>();
    const values = watch();
    const totalBlocked = useCommanderSelector((state) =>
        getSummaryAdjustmentValueFromForm(state, {
            availabilityBlockId,
            dateTimeUtc,
            arrayField: values.fieldArrayAvailability,
        })
    );

    const reservationCapacity = useCommanderSelector((state) =>
        getAllReservationCapacityInBlockByDateFromForm(state, {
            availabilityBlockId,
            dateTimeUtc,
            resourceCategories: values.fieldArrayAvailability.map((val) => val.resourceCategoryId),
        })
    );

    if (!occupancyInBlocksEnabledStage2 && (reservationCapacity === 0 || totalBlocked === 0)) {
        return null;
    }

    return (
        <BlockSetupMatrixVectorTotalCell>
            <Stack>
                <Typography textStyle="bodySmallStrong" as="div">
                    {totalBlocked}
                </Typography>
                <Typography textStyle="bodySmall" variant="secondary" as="div">
                    {SpacedForwardSlash}
                    {reservationCapacity}
                </Typography>
            </Stack>
        </BlockSetupMatrixVectorTotalCell>
    );
};

export default TotalCellEditableMode;
